import { Injectable } from '@angular/core';
import { US_STATES } from '../constants/states.constants';
import { COUNTRIES } from '../constants/countries.constants';

export interface HarpLocation {
  name: string;
  abbrev: string;
}

export const sortByName = (a: HarpLocation, b: HarpLocation) =>
  a.name.localeCompare(b.name);

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  states: HarpLocation[] = US_STATES.sort(sortByName);
  countries: HarpLocation[] = COUNTRIES.sort(sortByName);

  getStates(): HarpLocation[] {
    return this.states;
  }

  getCountries(): HarpLocation[] {
    return this.countries;
  }
}
